var extend = require("extend");

function Vector(x,y)
{
    this.x = x;
    this.y = y;
}

extend(Vector.prototype, {
    add: function(x,y)
    {
        if (y === undefined)
        {
            this.x += x.x;
            this.y += x.y;
        }
        else
        {
            this.x += x;
            this.y += y;
        }
        return this;
    },
    subtract: function(x,y)
    {
        if (y === undefined)
        {
            this.x -= x.x;
            this.y -= x.y;
        }
        else
        {
            this.x -= x;
            this.y -= y;
        }
        return this;
    },
    scale: function(s)
    {
        this.x *= s;
        this.y *= s;
        return this;
    },
    len: function ()
    {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    },
    norm: function(len)
    {
        var invLen = (len || 1) / this.len();
        return this.scale(invLen);
    },
    copy: function ()
    {
        return new Vector(this.x,this.y);
    },
    toString: function()
    {
        return "( " + this.x + ", " + this.y +")";
    }
});


module.exports = Vector;
